export const C = { navy: "#0B1E3B", red: "#E01A2E", cream: "#EFECE4", body: "#F7F5F0", slate: "#5B6B7E", green: "#1E9E63", ink: "#1A1E24", amber: "#F5A623", blue: "#2563EB" };
export const MONO = "'JetBrains Mono', ui-monospace, monospace";

export const STAGE_COLORS = {
  not_contacted: "#9AA5B1", contacted: "#5B6B7E", delivered: "#2563EB", opened: "#7C5CFF",
  clicked: C.amber, activated: C.green, debit_signed: C.navy,
};

export const STAGE_LABELS = {
  not_contacted: "Not contacted", contacted: "Emailed / invited", delivered: "Delivered", opened: "Opened",
  clicked: "Clicked a link", activated: "App activated", debit_signed: "Debit order signed",
};

export const OUTCOME_COLORS = {
  sent: C.slate, delivered: C.blue, opened: "#7C5CFF", clicked: C.amber, bounced: C.red, failed: C.red, blocked: "#9AA5B1",
};

export const ACTIONS = {
  welcome_pack: { label: "Send welcome pack", confirm: "send the welcome pack", verb: "email the app invite and debit-order form" },
  debit_order: { label: "Send debit order", confirm: "send the debit order", verb: "email only the debit-order form" },
  fix_email: { label: "Fix email & resend", confirm: "save & resend", verb: "save the corrected email and send the welcome pack" },
  whatsapp: { label: "WhatsApp invite", confirm: "open WhatsApp", verb: "open WhatsApp with their personal invite link" },
};

export const ago = (days) => (days == null ? "never mailed" : days === 0 ? "today" : days === 1 ? "1 day ago" : `${days} days ago`);
export const when = (v) => (v ? String(v).slice(0, 16).replace("T", " ") : "—");

export const Eyebrow = ({ children }) => (
  <div style={{ fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: C.slate, fontFamily: MONO }}>{children}</div>
);

export const Pill = ({ color, children, testid }) => (
  <span data-testid={testid} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "2px 9px", borderRadius: 999, fontSize: 11, fontWeight: 600, color, background: `${color}14`, border: `1px solid ${color}40`, whiteSpace: "nowrap" }}>
    <span style={{ width: 6, height: 6, borderRadius: 999, background: color }} />{children}
  </span>
);
